module.exports = __webpack_public_path__ + "img/titulo-observatorio.54391062.png";